export const GET_GROUP_DAYS_SUCCESS = 'GET_GROUP_DAYS_SUCCESS';
export const SET_FETCHING_GROUP_DAYS = 'SET_FETCHING_GROUP_DAYS';